import { Event } from './event';

export class EnrolmentGroupingChangedEvent extends Event<void> {}
